// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CodeMirror {\n  font-size: 16px;\n  height: auto;\n}\n", "",{"version":3,"sources":["webpack://./../../libraries/javascript/components/src/CodeEditor/CodeEditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":[".CodeMirror {\n  font-size: 16px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
